export const subs = state => state.subscriptionTypes;
// eslint-disable-next-line consistent-return
export const defaultSubs = (state) => {
  if (state.subscriptionTypes !== null) {
    return state.subscriptionTypes.filter(item => (item.is_default ? item : false));
  }
};
